module.exports = require('./lib/components/EllipsisText');



/*****************
 ** WEBPACK FOOTER
 ** ./~/react-ellipsis-text/index.js
 ** module id = 3375
 ** module chunks = 0
 **/